<template>
  <div class="section section_no-padding">
    <div class="hero">
      <div class="max-width">
        <div class="hero__grid">
          <div class="hero__about">
            <h1 class="section__title">{{ title }}</h1>
            <div class="section__text">{{ text }}</div>
            <div class="section__buttons">
              <a :href="purchaseLink" class="shopify-button shopify-button_white" target="_blank">
                <svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.3887 35.827L31.3438 33.5882C31.3438 33.5882 27.4712 7.14648 27.4712 6.96499C27.4712 6.7834 27.2897 6.66244 27.1687 6.66244H24.5064L22.4491 4.54468V35.827H22.3887Z" fill="currentColor" />
                  <path d="M21.3591 4.24208L20.3305 4.54463C20.2094 4.12112 20.0279 3.69751 19.8464 3.27399C19.3019 1.94283 18.0312 1.0957 16.6395 1.03517H16.337L16.2159 0.91421C15.6714 0.309107 14.8243 -0.0539755 13.9772 0.0065547C12.283 0.0065547 10.5283 1.27719 9.19711 3.51601C8.22903 5.0892 7.56339 6.78345 7.26084 8.59866L3.87244 9.62728C2.90436 9.92983 2.84383 9.99026 2.72276 10.8979C2.6018 11.624 0 32.015 0 32.015L21.5406 35.7665V4.12112L21.3591 4.24208ZM16.3975 5.81527L12.767 6.96494C13.0696 5.63378 13.7352 4.36314 14.5823 3.33452C14.9453 2.97144 15.3689 2.60836 15.7924 2.42687C16.2765 3.51602 16.458 4.66569 16.3975 5.81527ZM14.0377 1.21676C14.4007 1.21676 14.7638 1.27719 15.0664 1.51921C14.5823 1.82177 14.0982 2.12432 13.7352 2.54793C12.5855 3.93953 11.7989 5.57325 11.4964 7.32803L8.53148 8.23558C9.07605 5.51272 11.4358 1.27719 14.0377 1.21676ZM10.7098 17.1301C10.8308 19.0059 15.6109 19.4295 15.9135 23.786C16.1555 27.2349 14.0982 29.5947 11.2543 29.7158C9.25764 29.8972 7.32137 29.2316 5.86924 27.84L6.53478 24.6936C7.56339 25.4802 8.71307 25.9643 9.98371 26.0852C10.7098 26.0248 11.3149 25.4197 11.3149 24.6331C11.1938 22.2128 7.26084 22.3338 7.01882 18.4008C6.83733 15.0729 9.01562 11.6845 13.7957 11.382C14.7638 11.2609 15.7319 11.382 16.579 11.745L15.4899 15.92C14.6427 15.557 13.7352 15.3755 12.8275 15.436C10.7098 15.436 10.7098 16.7672 10.7098 17.1301ZM17.5471 5.45229C17.5471 4.36314 17.3656 3.33452 17.0025 2.30581C18.3337 2.54783 18.9388 4.06059 19.2413 4.96814L17.5471 5.45229Z" fill="currentColor" />
                </svg>
                <span>
                <span class="shopify-button__note">Find it on the</span>
                <span class="shopify-button__title">Shopify Theme Store</span>
              </span>
              </a>
            </div>
          </div>

          <div class="hero__pic">
            <img :src="imgMain" :srcset="imgSet" loading="lazy" :alt="imgAlt">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroView',
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    purchaseLink: { type: String, required: true },
    previewLink: { type: String, required: true },
    price: { type: String, default: '$0' },
    imgMain: { type: String, required: true },
    imgSet: { type: String, required: false },
    imgAlt: { type: String, required: false }
  }
}
</script>

<style lang="scss">
  .hero {
    background:url('@/assets/imgs/hero-bg.webp') no-repeat 50% 100%;
    background-size:cover;
    padding:8.75rem 0 0;

    @include xs {
      padding:7rem 0 0;
    }

    &__grid {
      display:flex;
      justify-content:space-between;
      gap:3rem;

      @include lg {
        flex-direction:column;
        gap:2.5rem;
        align-items:center;
      }
    }

    &__about {
      padding-top:1.75rem;
      max-width:456px;
      flex:none;

      @include lg {
        padding:0;
        max-width:580px;
        text-align:center;
      }

      .section__title {
        color:#fff;
      }

      .section__text {
        color:#fff;
        opacity:.6;
      }

      .section__buttons {
        flex-wrap:wrap;

        @include lg {
          justify-content:center;
        }

        .button {
          @include xs {
            padding:0;
            flex:auto;
          }

          &_white-border {
            gap:6px;

            svg {
              width:22px;
              height:auto;
              transform:none;
            }
          }
        }
      }
    }

    &__pic {
      img {
        filter:drop-shadow(0 0 29px rgba(127, 127, 127, 0.1));
      }
    }
  }
</style>
